module.exports = __webpack_public_path__ + "static/media/loading.607e6a6d.mov";